<template>
  <div>
    <md-field>
      <label>Bitte eigenen Namen eingeben</label>
      <md-input v-model="name"></md-input>
    </md-field>
    <md-button
      v-if="name"
      class="md-raised md-primary"
      @click.prevent="onSuccess(name)"
    >
      <md-icon>face</md-icon>
      Name speichern
    </md-button>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    onSuccess: Function
  },
  data() {
    return {
      name: ""
    };
  },
  methods: {},
  mounted() {},
  computed: {}
};
</script>
<style lang="sass" scoped></style>
